import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro";
import BackgroundImage1 from "images/custom/Scenarios-Background1.jpeg";
import BackgroundImage2 from "images/custom/Scenarios-Background2.png";
import BackgroundImage3 from "images/custom/Scenarios-Background3.jpeg";
import PhoneFrame from "images/custom/phone.png";
import SmartTimelapseVideo from "images/custom/Smart_Timelapse_trimmed.mp4";
import SmartDailyDemoVideo from "images/custom/Smart_Daily_Demo.mp4";
import { HASH_SCENARIOS } from "helpers/Constants";

const Container = tw.div`relative -mx-8`;

const Card = styled.div(props => [
  tw`md:flex justify-center items-center py-40`,
  css`
    ${props.backgroundCSS}
  `,
  props.reversed ? tw`flex-row-reverse` : "flex-row"
]);
const MediaContainer = styled.div(props => [
  //`background-image: url("${props.imageSrc}"); `,
  props.hasFrame
    ? `video {
    position: absolute;
    top: 2.5rem;
    left: 1.2rem;
    z-index: 1;
    object-fit: cover;
    width: 16rem;
    height: 19.5rem;
    object-position: top;
    @media (min-width: 768px) { 
      top: 2.7rem; 
      height: 31rem;
      object-position: center;
    }
    }
    img {
      position: absolute;
      z-index: 2;
      object-fit: contain;
      clip: rect(0, 20rem, 22rem, 0);
      @media (min-width: 768px) {  
        clip: auto;
      }
    }
  `
    : `video {
  object-fit: cover;
  height: 20rem;
  @media (min-width: 768px) {  
    height: 36rem; 
  }
}`,
  props.hasFrame
    ? tw`relative w-72 md:w-72 flex-shrink-0 h-96 md:h-144 md:bg-contain bg-cover md:bg-center bg-top mx-auto sm:mx-auto md:mx-auto lg:mx-8`
    : tw`md:w-1/2 lg:w-5/12 xl:w-1/3 flex-shrink-0 h-80 md:h-144 bg-center mx-4 sm:mx-8 md:mx-4 lg:mx-8`
]);
const Details = styled.div`
  background: rgba(255, 255, 255, 0.7);
  ${tw`mt-4 p-5 md:mt-0 md:max-w-lg mx-4 sm:mx-8 md:mx-4 lg:mx-20`}
`;
const Subtitle = tw.div`font-bold text-lg lg:text-2xl tracking-tight text-skywatch-primary800`;
const Title = tw.h4`text-4xl lg:text-5xl font-bold text-skywatch-textGray`;
const Description = tw.p`mt-2 text-base lg:text-lg font-normal text-skywatch-textGray leading-normal`;

export default () => {
  const cards = [
    {
      imageSrc: PhoneFrame,
      subtitle: "房東代管也能如此輕鬆",
      title: "公共設施管理",
      description:
        "不用 24 小時監控也能快速掌握每個重要時刻，當房客回報公共設施發生故障或毀損時，透過圖像日誌就能即刻找到問題發生的時間點與當時使用的房客。",
      backgroundCSS: `background: url(${BackgroundImage1}); background-position: center; background-size: cover;`,
      videoSrc: SmartDailyDemoVideo
    },

    {
      imageSrc: "",
      subtitle: "共享空間與連鎖商家的聰明首選",
      title: "重點監控一手掌握",
      description:
        "使用 Skywatch 智慧監控來精簡人力，邁向全自動化智慧管理。透過過濾重要影像來調整播放速度，將 24 小時的影像摘要成 10 分鐘內的短片，拿起手機就能快速掌握員工與顧客的一日大小事。",
      backgroundCSS: `background: linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), url(${BackgroundImage2}); background-position: center; background-size: cover;`,
      videoSrc: SmartTimelapseVideo
    },

    {
      imageSrc: PhoneFrame,
      subtitle: "寵物影像與你的顧客輕鬆分享",
      title: "輕鬆分享觀看權限",
      description:
        "使用 Skywatch 輕鬆分享寵物影像給特定飼主，讓顧客安心有保障；結束後輕鬆移除顧客觀看權限，免除隱私疑慮。",
      backgroundCSS: `background: linear-gradient(0deg, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.4)), url(${BackgroundImage3}); background-position: center; background-size: cover;`,
      videoSrc: SmartDailyDemoVideo
    }
  ];

  return (
    <Container id={HASH_SCENARIOS}>
      {cards.map((card, i) => (
        <Card key={i} reversed={i % 2 === 1} backgroundCSS={card.backgroundCSS}>
          <MediaContainer hasFrame={i % 2 === 0}>
            <video muted loop autoPlay playsInline>
              <source src={card.videoSrc}></source>
            </video>
            <img src={card.imageSrc} alt="" />
          </MediaContainer>
          <Details>
            <Subtitle>{card.subtitle}</Subtitle>
            <Title>{card.title}</Title>
            <Description>{card.description}</Description>
          </Details>
        </Card>
      ))}
    </Container>
  );
};
